import type { RegisteredComponent } from "@builder.io/sdk-react";

import { SpenderTickerSection } from "~/hec/components/spender-page/spender-sections";

/** COM-472/474: the deadline ticker as an authored block on the FSA Spender page. */
const FsaDeadlineTickerBlock = ({
  deadline,
  attributes,
}: {
  deadline?: string;
  attributes?: Record<string, unknown>;
}) => (
  <div data-testid="fsa-deadline-ticker-block-root" {...attributes}>
    <SpenderTickerSection deadline={deadline} />
  </div>
);

export const FsaDeadlineTickerDefinition = {
  component: FsaDeadlineTickerBlock,
  name: "FsaDeadlineTicker",
  friendlyName: "FSA Spender deadline ticker (FSA only)",
  noWrap: true,
  canHaveChildren: false,
  inputs: [
    {
      name: "deadline",
      type: "string",
      helperText:
        "Deadline day as YYYY-MM-DD (e.g. 2026-10-31). Counts down to the end of that day in the shopper's timezone. Empty: the shopper's own deadline.",
    },
  ],
} satisfies RegisteredComponent;

export default FsaDeadlineTickerBlock;
